<template>
  <el-menu class="navbar" mode="horizontal">
    <Hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></Hamburger>
    <div class="nav-title">
      <p>{{titleName}}</p>
      <div class="fr title-right">
        <a href="javascript:;" class="text-red back-to-home" v-if="!isOnly" @click="targetApp">
          <i class="el-icon-fa-reply"></i>
          返回业务系统
        </a>
        <a href="javascript:;" @click="$openService('统一用户中心', '统一用户中心')">
          <i class="el-icon-fa-comments"></i>
          联系客服
        </a>
        <a href="javascript:;" v-if="$store.getters.userInfo.simulate == 1" @click="cancel" class="right-info">
          <i class="el-icon-fa-sign-out"></i>
          注销
        </a>
        <a href="javascript:;" @click="logout" class="logout">
          <i class="el-icon-fa-power-off"></i>
          退出
        </a>
      </div>
      <div class="fr title-center">
        <i class="el-icon-fa-user"></i>
        {{userInfo.name}}
      </div>
    </div>
  </el-menu>
</template>
<script type="text/ecmascript-6">
  import Hamburger from '@/components/Hamburger/index'
  import logOutMixin from '@/components/layout/logout-mixin';

  export default {
    name: 'navbar',
    components: {
      Hamburger
    },
    mixins: [logOutMixin],
    data () {
      return {
        sidebar: this.$store.getters.sidebar,
        userInfo: this.$store.getters.userInfo,
      }
    },
    computed: {
      isOnly() {
        return localStorage.IPORTAL;
      },
      titleName() {
        return this.$store.state.api.PLATFORM_NAME ? this.$store.state.api.PLATFORM_NAME: '统一用户中心';
      }
    },
    created() {
      this.getAppsHref();
    },
    methods: {
      toggleSideBar () {
        this.$store.dispatch('ToggleSideBar');
      },
      getAppsHref () {
        let href = window.location.href;
        if (href.indexOf("uri=") > -1) {
          let uri = href.substr(href.indexOf("uri=") + 4);
          localStorage.uri = decodeURIComponent(uri);
        }
      },
      targetApp() {
        let href = window.location.href;
        if (localStorage.uri) {
          window.location.href = localStorage.uri;
        } else if (href.indexOf("uri=") > -1) {
          var uri = href.substr(href.indexOf("uri=") + 4);
          window.location.href = decodeURIComponent(uri);
        } else {
          this.$router.push({name: 'platform'})
        }
        localStorage.removeItem('uri');
      }
    }
  }
</script>
<style lang="less" scoped>
  @hoverColor: rgb(77, 179, 255);
  .navbar {
    height: 50px;
    line-height: 50px;
    border-radius: 0px !important;
    position: fixed;
    left: 160px;
    top: 0;
    right: 0;
    transition: all .28s ease-out;
    z-index: 2;

    .nav-title {
      margin-left: 20px;
      p {
        font-size: 20px;
        color: rgb(132, 146, 166);
        text-align: left;
        float: left;
        margin: 0;
      }
      .title-right {
        position: relative;
        margin-right: 20px;
        font-size: 12px;

        a {
          color: #96a3b5;
          margin-left: 10px;
          &:hover {
            color: @hoverColor;
          }
        }

      }
      .title-center {
        height: 40px;
        line-height: 40px;
        margin-top:5px;
        padding-right:12px;
        border-right:1px solid #c3cfdd;
        font-size:12px;
        color: #96a3b5;
      }
    }
    .hamburger-container {
      line-height: 58px;
      height: 50px;
      float: left;
      padding: 0 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/Navbar.vue